import React from 'react'
import { Box } from '@mui/material';


const SiteDetailMap = ({ longitude, latitude }) => {
    console.log(longitude,latitude);

    if (!latitude || !longitude) {
      return null;
    }

    const mapUrl = `https://maps.google.com/maps?q=${latitude},${longitude}&hl=es;z=14&amp&output=embed`;

  return (
        <iframe src = {mapUrl}
        height={250}
        style={{ border: 0 }}
        width= {'100%'}
        ></iframe>

  );
};

export default SiteDetailMap;